import { useCallback, useMemo, useState } from "react";
import { useGetOpenTillSessionsQuery } from "../store/api";
import { useStore } from "../context/StoreContext";
import { useDeviceCashSessionResolution } from "./useDeviceCashSession";

export const useSubmitCashSessionGuard = () => {
  const { selectedStoreId } = useStore();
  const [isStartSessionRequested, setIsStartSessionRequested] = useState(false);

  const {
    data: openSessionsData,
    isLoading: openSessionsLoading,
    isFetching: openSessionsFetching,
  } = useGetOpenTillSessionsQuery(selectedStoreId, { skip: !selectedStoreId });

  const openSessions = useMemo(
    () => (Array.isArray(openSessionsData) ? openSessionsData : []),
    [openSessionsData],
  );
  const deviceSessionResolution = useDeviceCashSessionResolution(
    openSessions,
    Boolean(selectedStoreId),
  );

  const isCheckingCashSession =
    openSessionsLoading ||
    openSessionsFetching ||
    deviceSessionResolution.isLoading;
  const hasActiveCashSession = deviceSessionResolution.status === "ready";

  const ensureActiveCashSession = useCallback(() => {
    if (hasActiveCashSession) return true;
    setIsStartSessionRequested(true);
    return false;
  }, [hasActiveCashSession]);

  const clearStartSessionRequest = useCallback(() => {
    setIsStartSessionRequested(false);
  }, []);

  const requestStartSession = useCallback(() => {
    setIsStartSessionRequested(true);
  }, []);

  return {
    clearStartSessionRequest,
    ensureActiveCashSession,
    hasActiveCashSession,
    isCheckingCashSession,
    isStartSessionRequested,
    requestStartSession,
  };
};
